import Vue from "vue";
import VueRouter from "vue-router";
import SingleLayout from "../layouts/SingleLayout.vue";
import DefaultLayout from "../layouts/DefaultLayout.vue";
import IntermediateLayout from "../layouts/IntermediateLayout.vue";

import { AmplifyEventBus } from "aws-amplify-vue";
import { getUser } from "@/utils/auth.js";
import { Loading } from "quasar";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "home",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/medicos/Home.vue"),
        meta: { requiresAuth: true }
      },
      {
        path: "profile",
        name: "MyPerfil",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/user/Profile.vue"),
        meta: { requiresAuth: true }
      },
      {
        path: "",
        component: IntermediateLayout,
        children: [
          {
            path: "/pacientes",
            name: "pacientesList",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "../views/pacientes/List.vue"
              ),
            meta: { requiresAuth: true, groups: ["medicos", "admins"] }
          },
          {
            path: "/pacientes/:id",
            name: "pacientesCrud",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "../views/pacientes/Crud.vue"
              ),
            meta: { requiresAuth: true, groups: ["medicos", "admins"] }
          }
        ]
      },
      {
        path: "/encuestas",
        name: "encuestasList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/pacientes/encuestas/List.vue"
          ),
        meta: { requiresAuth: true, groups: ["pacientes", "admins"] }
      },
      {
        path: "/encuestas-tipo",
        name: "encuestasTipoList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/medicos/encuestas/List.vue"
          ),
        meta: { requiresAuth: true, groups: ["medicos", "admins"] }
      },
      {
        path: "/reportar-sugerencia",
        name: "reportarSugerencia",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/user/ReportarSugerencia.vue"
          ),
        meta: { requiresAuth: true, groups: ["medicos", "pacientes", "admins"] }
      },
      {
        path: "/encuestas-tipo/:id",
        name: "encuestasDummyData",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/medicos/encuestas/Index.vue"
          ),
        meta: { requiresAuth: true, groups: ["medicos", "admins"] }
      },
      {
        path: "/encuestas/:id/rapid3",
        name: "encuestaRapid3",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/pacientes/encuestas/rapid3/Index.vue"
          ),
        meta: { requiresAuth: true, groups: ["pacientes", "medicos", "admins"] }
      },
      {
        path: "/pacientes/:id/historico",
        name: "encuestasHistoricoPacientesList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/medicos/encuestas/Historico.vue"
          ),
        meta: { requiresAuth: true, groups: ["medicos", "admins"] }
      }
    ]
  },
  {
    path: "/auth",
    name: "auth",
    component: SingleLayout,
    children: [
      {
        path: "/signIn",
        component: () =>
          import(/* webpackChunkName: "signin" */ "../views/auth/SignIn.vue"),
        meta: { requiresAuth: false }
      },
      {
        path: "/resetPassword",
        component: () =>
          import(
            /* webpackChunkName: "resetPassword" */ "../views/auth/ResetPassword.vue"
          ),
        meta: { requiresAuth: false }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

getUser().then(user => {
  if (user) {
    router.push({ path: "/home" });
  }
});

AmplifyEventBus.$on("authState", async state => {
  const pushPathes = {
    signedOut: () => {
      router.push({ path: "/signIn" });
    },
    signUp: () => {
      router.push({ path: "/signUp" });
    },
    confirmSignUp: () => {
      router.push({ path: "/signUpConfirm" });
    },
    signIn: () => {
      router.push({ path: "/signIn" });
    },
    signedIn: () => {
      router.push({ path: "/home" });
    },
    resetPassword: () => {
      router.push({ path: "/resetPassword" });
    }
  };
  if (typeof pushPathes[state] === "function") {
    pushPathes[state](state);
  }
});

router.beforeEach((to, from, next) => {
  Loading.show();
  next();
});

router.afterEach(() => {
  setTimeout(() => Loading.hide(), 500);
});

router.beforeResolve(async (to, from, next) => {
  const user = await getUser();
  if (!user) {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      return next({
        path: "/signIn"
      });
    }
  } else {
    const userGroup = user.attributes["custom:group"];
    if (
      to.matched.some(
        record =>
          typeof record.meta.requiresAuth === "boolean" &&
          !record.meta.requiresAuth
      )
    ) {
      if (to.path === "/home" && "pacientes" === userGroup) {
        return next({
          path: "/encuestas"
        });
      }
      return next({
        path: "/home"
      });
    }

    if (to.meta) {
      const groups = to.meta.groups;
      if (groups && groups.length) {
        if (groups.indexOf(userGroup) < 0) {
          return next({
            path: "/home"
          });
        }
      }
    }

    if (to.path === "/home" && "pacientes" === userGroup) {
      return next({
        path: "/encuestas"
      });
    }
  }
  return next();
});

export default router;
